import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";
import { modalEventListener } from "../../../utils/ModalEventListener";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { formatAmount } from "../../../utils/format";
import { ToastContainer, toast } from "react-toastify";
import { axios_instance } from "../../../api/axios_instance";
import { format } from "date-fns";
import ModalWrapper from "../../../layouts/ModalWrapper";

const ConfirmationModal = ({
  closeConfirmationModal,
  confirmationData,
  confirmationMessage,
  confirmationAction,
  fetchListData,
  showConfirmationModal,
}) => {
  const [state, setState] = useState([]);
  const [listData, setListData] = useState(confirmationData);

  const handleModalClose = () => {
    closeConfirmationModal();
    setState([]);
    setListData(confirmationData);
  };

  useEffect(() => {
    setListData(confirmationData);
  }, [confirmationData]);

  const ref = useRef();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    return modalEventListener(ref, handleModalClose);
  }, [handleModalClose]);

  const handleCheckboxChange = (e, idx) => {
    const { name, checked } = e.target;
    let tempList = [...listData];

    if (name === "selectall") {
      tempList = tempList.map((data) => ({
        ...data,
        isChecked: checked,
      }));

      const temp = checked ? [...confirmationData] : [];
      setState(temp);
      setListData(tempList);
    } else {
      const updatedState = [...state];

      if (checked) {
        if (!updatedState.includes(confirmationData[idx])) {
          updatedState.push(confirmationData[idx]);
          tempList[idx] = { ...tempList[idx], isChecked: true };
        }
      } else {
        const itemToRemove = confirmationData[idx];
        const removeIdx = updatedState.indexOf(itemToRemove);
        if (removeIdx > -1) {
          updatedState.splice(removeIdx, 1);
        }
        tempList[idx] = { ...tempList[idx], isChecked: false };
      }

      setState(updatedState);
      setListData(tempList);
    }
  };

  const confirmLeadSubmission = async () => {
    try {
      if (!state.length) {
        toast.dismiss();
        return toast.error("Please select a record", { theme: "colored" });
      }

      const result = await axios_instance({
        url: "/bulkbank/leadSubmission",
        method: "POST",
        data: {
          leads: state,
          action: "confirmation_leads",
        },
      });

      if (result.status === 200) {
        await fetchListData(true);
        toast(
          <>
            <span className="glyphicon glyphicon-ok-sign"></span>
            {"Payment row successfully added"}
          </>
        );
      }
    } catch (error) {
    } finally {
      handleModalClose();
    }
  };

  return ReactDOM.createPortal(
    <ModalWrapper show={showConfirmationModal} onClose={handleModalClose}>
      <div className="modal-wrapper">
        <ToastContainer
          closeOnClick={false}
          draggable={false}
          closeButton={false}
        />
        <div
          className="confirmation-modal-content add-row-confirmation-modal"
          ref={ref}
        >
          <div className="modal-header">
            <button className="close" onClick={handleModalClose}>
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 className="modal-title" id="">
              Confirmation{" "}
              <span className="conf-mesg col-red">{confirmationMessage}</span>
            </h4>
          </div>
          <div className="modal-body clearfix">
            <div className="tableBox">
              <table className="table table-striped table-hover table-bordered">
                <thead className="thead-default">
                  <tr>
                    <th>
                      <input
                        type="checkbox"
                        className="bulk-payment-panel-all-chkd"
                        id="bulk-payment-chck"
                        name="selectall"
                        onChange={(e) => handleCheckboxChange(e, -1)}
                        checked={confirmationData.length === state.length}
                      />
                      <label htmlFor="bulk-payment-chck">
                        <span className="dt-yes"></span>
                      </label>
                    </th>
                    <th>Loan ID</th>
                    <th>Bank Payment</th>
                    <th>Payment Date</th>
                    <th>Disbursing Bank</th>
                    <th>City</th>
                    <th>Previous Payment</th>
                    <th>Customer Name</th>
                    <th>Car Reg no.</th>
                    <th>Car Name</th>
                    <th>Added By</th>
                  </tr>
                </thead>
                <tbody id="bankPayment_conf_body">
                  {confirmationMessage === "(No Matching Record Found!)" ? (
                    <tr>
                      <td>
                        <input
                          className="confirmation-box-chkd"
                          type="checkbox"
                          id="chk-cbox-1"
                          onChange={(e) => handleCheckboxChange(e, -1)}
                          // checked={areAllCheckboxesChecked()}
                        />
                        <label htmlFor={`chk-cbox-1`}>
                          <span className="dt-yes"></span>
                        </label>
                      </td>
                      <td></td>
                      <td>{confirmationData[0].bank_payment_amount}</td>
                      <td>
                        {format(
                          new Date(confirmationData[0].bank_payment_date),
                          "dd-MM-yyyy"
                        )}
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td>{user.name}</td>
                    </tr>
                  ) : (
                    listData.map((val, idx) => {
                      const { finance_lead_id } = val;
                      return (
                        <tr key={idx}>
                          <td>
                            <input
                              className="confirmation-box-chkd"
                              type="checkbox"
                              name={`chk-cbox-${idx}`}
                              id={`chk-cbox-${idx + 1}`}
                              onChange={(e) => handleCheckboxChange(e, idx)}
                              checked={val.isChecked}
                            />
                            <label htmlFor={`chk-cbox-${idx + 1}`}>
                              <span className="dt-yes"></span>
                            </label>
                          </td>
                          <td>
                            {" "}
                            <Link
                              to={`/payments/details?lead_id=${btoa(
                                finance_lead_id
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="add-row-confirmation-modal-link"
                            >
                              {finance_lead_id}
                            </Link>
                          </td>
                          <td>{val.bank_payment_amount}</td>
                          <td>
                            {format(
                              new Date(val.bank_payment_date),
                              "dd-MM-yyyy"
                            )}
                          </td>
                          <td>{val.bank_name}</td>
                          <td>{val.lead_city}</td>
                          <td>{formatAmount(+val.previousPayment)}</td>
                          <td>{`${val.customer_name} ${val.last_name}`}</td>
                          <td>{val.regno}</td>
                          <td>
                            {`${val.make} ${val.model} ${val.variant_name}`}
                          </td>
                          <td>{user.name}</td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="modal-footer text-center">
            <button
              className="btn rc-btn_rset pad-L20 pad-R20"
              onClick={handleModalClose}
            >
              Cancel
            </button>
            <button
              className="btn rc-btn_primary btn-lg"
              onClick={confirmLeadSubmission}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    </ModalWrapper>,
    document.querySelector(".myPortalModalDiv")
  );
};

export default ConfirmationModal;
